export default __webpack_public_path__ + "static/media/ordekdin.ebabc6f5.PNG";